import React , { Component } from "react";
import SEO from '../../components/seo';
import Layout from "../../components/layout";
import { Link } from "gatsby";
import ImageMainBanner from "../../images/rapidfresh-banner.png";
import ImageMainBannerVector from "../../images/RapidFreshMainBannerIcon.svg";
import IconRightArrow from "../../icons/icon-thank-you-arrow-right.svg"
import BannerSlideIn from "../../components/common/utils/animations/bannerSlideIn";
import IconCheckmarkImage from "../../icons/icon-checkmark.svg";
import LazyLoad from 'react-lazyload';
import { submitForm } from '../../components/common/templates/form/submitForm';
import 'react-phone-input-2/lib/style.css';
import { InView } from 'react-intersection-observer';
import scrollTo from 'gatsby-plugin-smoothscroll';
const emailValidation = RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(?!hotmail|gmail|yahoo|outlook|test|yop|icloud)(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

class RapidFresh extends Component {
    constructor(props) {
      super(props);
      this.textInput = null;
      this.referrer = null;
      this.state = {
        name: "",
        nameValidation: "",
        lastName: "",
        email: "",
        emailValidation: "",
        companyname: "",
        companynameValidation: "",
        jobTitle: "",
        shouldSubmit: false,
        showSuccess: false,
        submitButtonState: "",
        isInView: false,
        isVisible: true,
      };
    }
    clearFields = () => {
      this.setState({
        name: "",
        nameValidation: "",
        email: "",
        emailValidation: "",
        companyname: "",
        jobTitle:"",
        companynameValidation: "",
        shouldSubmit: false,
        showSuccess: false,
        submitButtonState: ""
      });
    };

    componentDidUpdate() {
      this.props.isVisible && this.nameRef.current.focus();
      this.referrer = document.referrer;
    }
  
    checkFields = () => {
      const { nameValidation, emailValidation, companynameValidation } = this.state;
      if (nameValidation === 'success-field' &&
        emailValidation === 'success-field' &&
        companynameValidation === 'success-field') {
        this.setState({
          shouldSubmit: true
        });
      }
      return {
        ...(!nameValidation) && { nameValidation: 'error-field', shouldSubmit: false },
        ...(!emailValidation) && { emailValidation: 'error-field', shouldSubmit: false },
        ...(!companynameValidation) && { companynameValidation: 'error-field', shouldSubmit: false },
      };
    };
  
    onSubmit = (event) => {
      event.preventDefault();
      if (this.state.submitButtonState === '') {
        this.setState(this.checkFields(),
          async () => {
            if (this.state.shouldSubmit) {
              this.setState({
                submitButtonState: "inProgress"
              });
  
              let formData = new FormData();
              formData.append("form_id", 12);
              formData.append("input_1", this.state.name);
              formData.append("input_3", this.state.email);
              formData.append("input_5", this.referrer);
              formData.append("input_6", this.props.location.pathname);
              formData.append("input_7", this.state.companyname);
              formData.append("input_8", this.state.lastName)
              formData.append("input_11", this.state.jobTitle);
              formData.append("input_12", "https://www.rapidops.com/resources/datasheet-rapidFRESH.pdf");
              formData.append("input_13", "Rapidops - Your rapidFRESH datasheet is here");
              formData.append("input_14", "rapidFRESH datasheet - Digital ordering and fulfilment platform")
              formData.append("input_15", "DS-RAPIDFRESH-AUG21-WEB" )
  
              const requestData = {
                method: 'post',
                url: 'https://rapidopsbackend.kinsta.cloud/wp-json/gf/v2/forms/12/submissions',
                data: formData
              };
  
              try {
                const response = await submitForm(requestData);
                if (response.status === 200 || response.status === 201) {
                  setTimeout(() => {
                    this.setState({
                      submitButtonState: "finished",
                      isVisible: false
                    });
                  }, 200);
                }
                setTimeout(() => {
                  this.clearFields();
                  this.setState({
                    showSuccess: true
                  })
                }, 200);
              }
              catch (error) {
                console.log(error);
              }
            }
          });
      }
    };
  
  
    handleChange = (e) => {
      const name = e.target ? e.target.name : 'phone';
      const value = e.target ? e.target.value : e;

      switch (name) {
        case 'name':
          if (!value)
            this.setState({
              nameValidation: 'error-field',
              shouldSubmit: false,
            });
          else
            this.setState({
              nameValidation: 'success-field',
            });
          break;
  
  
        case 'email':
          if (!emailValidation.test(value))
            this.setState({
              emailValidation: 'error-field',
              shouldSubmit: false,
            });
          else
            this.setState({
              emailValidation: 'success-field',
            });
          break;
  
  
        case 'companyname':
          if (value.length < 5)
            this.setState({
              companynameValidation: 'error-field',
              shouldSubmit: false,
            });
          else
            this.setState({
              companynameValidation: 'success-field',
            });
          break;
  
        default:
          break;
      }
      const newState = {};
      newState[name] = value;
      this.setState(newState);
    };
  
    nameFocus = () => {
      this.textInput.focus();
    }
  
    inViewChange = (view) => {
      this.setState({
        isInView: view
      })
    }
  
    render() {
      const { nameValidation, emailValidation, companynameValidation, showSuccess, submitButtonState, isVisible } = this.state;
      return (
        <>
        <Layout addBodyClass="infographic-page transparent-header rapid-fresh-page" footerFormType="basic">
        <SEO description="rapidSHOP is an end-to-end omnichannel platform, enables retailers offer a seamless and personalized shopping experience across web, mobile, and stores."
              meta={[{ name: "charSet", content: "utf-8" }]}
              title="rapidFRESH – a complete omnichannel platform for retail- Data Sheet" />
          <div className="page-main-banner-section page-main-banner-liquid-image section-gap d-flex align-v-center rapidfresh">
            <div className="container">
              <div className="row d-flex flex-wrap justify-space">
                <div className="col page-main-banner-detail">
                  <div className="page-main-banner-detail-inner">
                    <span className="theme-color-title">DATASHEET - RAPidfresh</span>
                    <h1 className="h1">Unlock Fresh Food & Deli Experience</h1>
                    <p>rapidFRESH is an end-to-end fresh food and grocery platform to enable your AI-powered, modern, and hyper-personalized shopping experience for your customers. It allows online ordering, delivery, and fulfillment of made-to-order fresh products. Powered by modern architecture and enterprise-focused design, rapidFRESH flawlessly integrates with existing enterprise systems with its built-in analytics, reporting, and operational functions. To find out more, fill out some basic info and download our free datasheet.</p>
                  </div>
                  <div id="form-section-scroll"></div>
                  <div className="form-section-infographic" id={this.props.id ? this.props.id : "form-section"}>
                    {!showSuccess &&
                      <div className="form-section-infographic-inner">
                        <span className="form-title h3">Download Datasheet</span>
                        <form name="infographic" onSubmit={this.onSubmit} className="fomt-style-round">
                          <div className="form-row has-two-column">
                            <div className="form-column">
                              <input ref={(elem) => (this.textInput = elem)} placeholder="First Name*" type="text" className={`form-input LoNotSensitive ${nameValidation}`} id="name" name="name" autoComplete="off" onChange={this.handleChange} value={this.state.name} tabIndex="1" />
                            </div>
                            <div className="form-column">
                              <input placeholder="Last Name" type="text" className="form-input LoNotSensitive" id="lastName" name="lastName" autoComplete="off" onChange={this.handleChange} value={this.state.lastName} tabIndex="2" />
                            </div>
                          </div>
                          <div className="form-row">
                            <div className="form-column">
                              <input placeholder="Work Email*" type="email" name="email" className={`form-input LoNotSensitive ${emailValidation}`} id="email" autoComplete="off" onChange={this.handleChange} value={this.state.email} tabIndex="3" />
                              <small className={`${emailValidation}`}>Please enter your work email.</small>
                            </div>
                          </div>
                          <div className="form-row">
                            <div className="form-column">
                              <input ref={this.nameRef} placeholder="Company*" type="text" className={`form-input LoNotSensitive ${companynameValidation}`} id="companyname" name="companyname" autoComplete="off" onChange={this.handleChange} value={this.state.companyname} tabIndex="4" />
                            </div>
                          </div>
                          <div className="form-row">
                            <div className="form-column">
                              <input placeholder="Job Title" type="text" name="jobTitle" className="form-input LoNotSensitive" id="jobTitle" autoComplete="off" onChange={this.handleChange} value={this.state.jobTitle} tabIndex="5" />
                            </div>
                          </div>
                          <div className="form-action">
                            <button type="submit" className={`button right-arrow button-white  ${submitButtonState}`} tabIndex="6" >
                              <span className="submit">Download</span>
                              <span className="loading"> Download </span>
                              <span className="check"> <IconCheckmarkImage /> </span>
                            </button>
                            <p>By submitting this form you agree to our <Link to="/privacy-policy/">Privacy Policy</Link>.</p>
                          </div>
                        </form>
                      </div>
                    }
                    {showSuccess &&
                      <div className="thank-you-infographics">
                        <h3>Thank you for downloading! </h3>
                        <p>Please check your email for downloading <span className="green-color"> rapidFRESH datasheet - Digital ordering and fulfilment platform. </span></p>
                        <strong>TAKE THE NEXT STEP &nbsp; <IconRightArrow /> </strong>
                        <p className="mb-40">Want to explore your opportunities with our digital retail solutions? Just drop us a line.</p>
                        <Link to="/contact/" className="button right-arrow button-white">Contact Us</Link>
                      </div>
                    }
                  </ div>
                </div>
                <BannerSlideIn classes="col page-main-banner-image">
                  <LazyLoad>
                    <img className="main-img" src={ImageMainBanner} title="Fresh Food & Deli Experience Infographic" alt="personalized shopping experience" />
                    <img className="vector-img" src={ImageMainBannerVector} title="Fresh Food & Deli Experience Infographic" alt="personalized shopping experience" />
                  </LazyLoad>
                </BannerSlideIn>
              </div>
            </div>
          </div>
          <InView onChange={this.inViewChange}>
            <div className="about-infographic section-gap">
              <div className="container">
                <div className="row d-flex flex-wrap">
                  <div className="col left-side-content">
                    <div className="about-company-list">
                      <span className="about-company-list-count">200+</span>
                      <p>Product Features</p>
                    </div>
                    <div className="about-company-list">
                      <span className="about-company-list-count">13+</span>
                      <p>Markets Served</p>
                    </div>
                    <div className="sources-box">
                      <h4>And many more tangible benefits for both Retailers and Customers.</h4>
                    </div>
                  </div>
                  <div className="col right-side-content">
                    <h2>rapidFRESH Platform</h2>
  
                    <p>rapidFRESH empowers the fresh food departments to scale out their personalized services beyond the physical store boundaries to enterprises delivering seamless, scalable, and personalized shopping experiences across multi-channels. Its API-first and enterprise-focused design flawlessly integrates & orchestrates with existing enterprise systems and security. rapidFRESH offers bundle of features that exceeds consumer expectations, drives revenue, customer retention, & unlocks new avenues for growth while reducing costs & time required to prepare and deliver fresh food.</p>
  
                    <p>It includes: </p>
  
                    <ul>
                      <li>Complete ownership of customers, transactional data, and insights</li>
                      <li>Multi-store & multi-brand storefronts, customizable as per requirement</li>
                      <li>Ready-to-deploy, modular, & scalable components for faster time to market</li>
                      <li>Kitchen Processing System (KPS) enables staff to view, prepare, & dispatch order</li>
                      <li>AI-powered recommendations, customer engagement, and analytics capabilities</li>
                      <li>Maximize marketing initiatives by personalized recommendations & promotions</li>
                      <li>Intuitive shopping experience with award-winning UX & Navigation</li>
                    </ul>
                    <div className="col left-side-content">
                      <div className="about-company-list">
                        <span className="about-company-list-count">94%</span>
                        <p>of <strong>Fortune 1000 companies</strong> experienced supply chain disruptions during the Pandemic</p>
                      </div>
                      <div className="about-company-list">
                        <span className="about-company-list-count">3%</span>
                        <p><strong>shrink</strong> is expected in the global economy by <strong>2024</strong> </p>
                      </div>
                      <div className="sources-box">
                        <h4>Get access to 70+ insights from 20+ industry sources </h4>
                      </div>
                    </div>
                    {isVisible &&
                      <div onClick={() => scrollTo('#form-section-scroll')}><button className="button right-arrow button-white" onClick={this.nameFocus}>Download</button></div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="section-gap about-infographic-cta">
              <div className="container">
                <div className="dt-cta-section">
                  <div className="dt-cta-inner">
                    <div className="leftbar">
                      <h3>Explore how Rapidops can help you monetize your digital opportunities in Retail and Grocery.</h3>
                    </div>
                    <div className="rightbar">
                      <a className="button button-white-border right-arrow" href="/industries/retail/">Learn More</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </InView>
          </Layout>
        </>
      );
    }
  }

export default RapidFresh;